import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9238b83a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dp-skeleton-buttons" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dp-skeleton-button" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dp-skeleton-button" })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { DoctoraliaAuthentication } from "@/types/DoctoraliaAuthentication";
import { HeaderMfeOptions } from "@/types/HeaderMfe";
import { toHeaderUserIdentity } from "@/utils/dp-spaces-user-identity";
import { loadRemote } from "@docplanner/remotejs-runtime";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

interface SpacesModule {
  mount: (selector: string, options: { shadowDOM: boolean }) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DpSpacesHeader',
  emits: ["load", "error"],
  setup(__props, { emit: __emit }) {

function isSpacesModule(obj: unknown): obj is SpacesModule {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "mount" in obj &&
    typeof (obj as { mount?: unknown }).mount === "function"
  );
}

const store = useStore();

// Defines the events that the component can emit
const emit = __emit;

function safeReadCodeDpSpaces(): string | undefined {
  try {
    return sessionStorage.getItem("codeDpSpaces") ?? undefined;
  } catch {
    return undefined;
  }
}

function safeRemoveCodeDpSpaces(): void {
  try {
    sessionStorage.removeItem("codeDpSpaces");
  } catch {
    // degraded gracefully — sessionStorage unavailable
  }
}

// Defined reactive variables
const headerRef = ref<HTMLElement | null>(null);

console.log("[DP Spaces Header] Initializing");

// Define lifecycle hooks
onMounted(async () => {
  try {
    const header = await loadHeaderModule();
    header.mount("#dp-spaces-header", { shadowDOM: true });
    onHeaderToggle(false);
    console.log("[DP Spaces Header] Mounted");
    emit("load");
  } catch (e) {
    console.error("[DP Spaces Header] Error loading external module", e);
    onHeaderToggle(true);
    if (headerRef.value) {
      headerRef.value.innerHTML = "";
    }
    emit("error");
  }
});

function onHeaderToggle(isCollapsed: boolean) {
  headerRef.value?.parentElement?.classList.toggle("dp-collapsed", isCollapsed);
  store.commit("setDpSpacesCollapsed", isCollapsed);
}

async function loadHeaderModule(): Promise<SpacesModule> {
  const authenticationData: DoctoraliaAuthentication = await store.dispatch(
    "fetchDoctoraliaAuthentication"
  );

  let redirectURI: string;

  console.log("[DP Spaces Header] Current hostname:", window.location.hostname);
  console.log("[DP Spaces Header] Current pathname:", window.location.pathname);

  if (
    window.location.hostname === "app.feegow.com" ||
    window.location.hostname === "dasa.feegow.com" ||
    window.location.hostname === "demo.feegow.com" ||
    window.location.hostname === "app3.feegow.com" ||
    window.location.hostname === "app4.feegow.com" ||
    window.location.hostname === "franchising.feegow.com"
  ) {
    const trocouUnidade = document.userProperties?.trocouUnidadeNaSessao;
    console.log("[DP Spaces Header] trocouUnidadeNaSessao:", trocouUnidade);

    if (trocouUnidade === 1) {
      const currentPath = window.location.pathname.replace(/\/$/, "");
      console.log(
        "[DP Spaces Header] Unit change detected - preserving context:",
        currentPath
      );
      redirectURI = new URL(
        `${currentPath}/?P=Home&Pers=1`,
        `https://${window.location.hostname}/`
      ).toString();
      console.log(
        "[DP Spaces Header] Generated redirectURI for unit change:",
        redirectURI
      );
    } else {
      console.log(
        "[DP Spaces Header] First login or no unit change - using main path"
      );
      redirectURI = new URL(
        "main/?P=Home&Pers=1",
        `https://${window.location.hostname}/`
      ).toString();
      console.log(
        "[DP Spaces Header] Generated redirectURI for standard flow:",
        redirectURI
      );
    }
  } else {
    console.log("[DP Spaces Header] Using current href for other domains");
    redirectURI = window.location.href;
  }

  console.log("[DP Spaces Header] Final redirectURI:", redirectURI);

  const codeDpSpaces = safeReadCodeDpSpaces();

  const options: HeaderMfeOptions = {
    locale: "br",
    softwareProvider: "feegow",
    clientId: authenticationData?.clientId,
    onHeaderToggle,
    userIdentity: toHeaderUserIdentity(authenticationData?.userIdentity),
    redirectURI,
    onGoToPmsMainPage: () =>
      (window.location.href = `https://${window.location.hostname}/`),
    isUserIntegrated: Boolean(authenticationData),
    ...(codeDpSpaces && authenticationData ? { authCode: codeDpSpaces } : {}),
    onAuthCodeCleanup: safeRemoveCodeDpSpaces,
  };

  const remoteModule = await loadRemote({
    app: "integrations-patient-portal",
    name: "header",
    expose: "app",
    options,
  });

  if (!isSpacesModule(remoteModule)) {
    throw new Error("Loaded remote module is not a valid SpacesModule.");
  }

  return remoteModule;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "dp-spaces-header",
    ref_key: "headerRef",
    ref: headerRef
  }, _hoisted_2, 512))
}
}

})